import { z } from "zod";

export const campaignDetailsSchema = z.object({});

export type TCampaignDetailsSchemaData = z.infer<typeof campaignDetailsSchema>;
